import { useState, useCallback } from 'react';

import { AuthModalOptions, ModalContextValue } from '../ModalContext.types';

type UseAuthModalType = ModalContextValue['auth'] & {
    authModalOptions: AuthModalOptions;
};

export const useAuthModal = (): UseAuthModalType => {
    const [isOpen, setOpen] = useState(false);
    const [authModalOptions, setAuthModalOptions] = useState<AuthModalOptions>({});

    const open = useCallback((options: AuthModalOptions = {}) => {
        setAuthModalOptions(options);
        setOpen(true);
    }, []);

    const close = useCallback(() => setOpen(false), []);

    return { authModalOptions, isOpen, open, close };
};
